import { ReactElement } from 'react';
import { Page } from '@client/app/components/App/Page';
import { useTranslate } from '@client/i18n/hooks';
import { FilteringPanel } from '@client/manufacturer/components/ListPage/FilteringPanel';
import { ManufacturerType } from '@client/manufacturer/redux/manufacturers/types';
import { Alert, ALERT_DISPLAY_TYPE, ALERT_STYLE_TYPE } from '@lib/components/Alert';
import { CardBox } from '@lib/components/CardBox';
import { Props } from './ListPage.types';
import './ListPage.scss';

export const ListPage = ({
  filter,
  generateManufacturerUrl,
  manufacturers,
  onFilteringElementClick,
  onManufacturerNameClick,
  onSearchInputChange,
  query,
  queryKey,
  metaTags,
}: Props): ReactElement | null => {
  const t = useTranslate();

  if (!manufacturers || !manufacturers.data) {
    return null;
  }

  const filterChars = manufacturers.data._filterChars;
  const title = query ? `${t('Results for')}: "${query}"` : filter || '';

  const renderManufacturer = (manufacturer: ManufacturerType): ReactElement => {
    const url = generateManufacturerUrl(manufacturer);

    return (
      <li key={manufacturer.manufacturerId}>
        <a
          className="Manufacturers-ManufacturerName"
          onClick={onManufacturerNameClick(url)}
          href={url}
        >
          {manufacturer.name}
        </a>
        <span> - </span>
        <span className="Manufacturers-ManufacturerCategory">
          {manufacturer.category}
        </span>
      </li>
    );
  };

  return (
    <Page
      className='Manufacturers-ListPage'
      title={t('All manufacturers')}
      metaTags={metaTags}
    >
      <h1 className='PageTitle'>{t('All manufacturers')}</h1>
      <CardBox>
        <div className='Manufacturers-Navigation'>
          <input
            key={queryKey}
            defaultValue={query}
            type='text'
            placeholder={t('manufacturer name')}
            className='Manufacturers-Search'
            onChange={onSearchInputChange}
          />
          <FilteringPanel
            availableElements={filterChars}
            selectedElement={filter}
            onClick={onFilteringElementClick}
          />
        </div>
        <div className="Manufacturers-Results">
          <div className="Manufacturers-ResultsTitle">{title}</div>
          {manufacturers.data.manufacturers.length === 0 && (
            <Alert
              displayType={ALERT_DISPLAY_TYPE.text}
              styleType={ALERT_STYLE_TYPE.info}
            >
              {t('Your search did not return any results.')}
            </Alert>
          )}
          <ul className="Manufacturers-ResultsList">
            {manufacturers.data.manufacturers.map(renderManufacturer)}
          </ul>
        </div>
      </CardBox>
    </Page>
  );
};
